import React from 'react';
import { Eyebrow } from './Eyebrow';
const metrics = [{
  value: '240+',
  label: 'Praktycznych stron'
}, {
  value: '50',
  label: 'Gotowych ćwiczeń jazzowych'
}, {
  value: '6',
  label: 'Darmowych bonusów'
}, {
  value: '6',
  label: 'Kompletnych tomów'
}];
const coverage = ['Podstawy dla początkujących', 'Standardy na poziomie średnim', 'Zaawansowana improwizacja', 'Lekcje indywidualne i grupowe', 'Gry i gra zespołowa', 'Ocenianie i śledzenie postępów'];
export function SystemOverview() {
  return <section aria-labelledby="system-heading" className="bg-night py-16 sm:py-24" data-id="element-318" data-mp="pxg8m966lmvy">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-319" data-mp="13wfyfk5fk7tp">
        <div className="grid items-center gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,26rem)] lg:gap-16" data-id="element-320" data-mp="13ttesm59m1v4">
          <div data-id="element-321" data-mp="yzfogy5gmkxb">
            <Eyebrow data-id="element-322" data-mp="2fb2xv7khervw">Najbardziej kompletny system dla pedagogów gitary jazzowej</Eyebrow>
            <h2 id="system-heading" className="mt-5 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-323" data-mp="2ac8fu7uc97cu">
              Arsenał Nauczyciela <span className="text-amber" data-id="element-324" data-mp="238gtna76tsr9">Jazzu&trade;</span>
            </h2>
            <p className="mt-6 max-w-xl font-serif text-lg italic leading-relaxed text-cream-soft" data-id="element-325" data-mp="283w37py5x2hv">
              Ponad 240 stron kompletnych planów lekcji, profesjonalnych ćwiczeń, standardów,
              poradników technicznych i narzędzi do prowadzenia zajęć &mdash; wszystko już dla
              Ciebie przygotowane.
            </p>
            <dl className="mt-10 grid grid-cols-2 gap-y-8 border-t border-night-600 pt-8 sm:grid-cols-4" data-id="element-326" data-mp="1pez9bn6ogc06">
              {metrics.map(metric => <div key={metric.label} data-id="element-327" data-mp="1udakc18pksjz">
                  <dt className="sr-only" data-id="element-328" data-mp="1uc7rvovqmi1y">{metric.label}</dt>
                  <dd data-id="element-329" data-mp="1z5ke5scy2crj">
                    <span className="block font-display text-4xl leading-none text-amber sm:text-5xl" data-id="element-330" data-mp="1z6vlu39ig4nx">
                      {metric.value}
                    </span>
                    <span className="mt-2 block max-w-[9rem] text-[11px] font-semibold uppercase tracking-label text-cream-muted" data-id="element-331" data-mp="16n6r8nt5cb78">
                      {metric.label}
                    </span>
                  </dd>
                </div>)}
            </dl>
          </div>
          <div className="rounded-2xl border border-night-600 bg-night-800 p-7 sm:p-8" data-id="element-332" data-mp="18dv66kwvah3y">
            <p className="text-[11px] font-semibold uppercase tracking-label text-amber" data-id="element-333" data-mp="13dz1ejgcilnc">
              Pełny zakres
            </p>
            <p className="mt-2 font-display text-2xl leading-tight text-cream" data-id="element-334" data-mp="fpg1osbd3h6v">
              Jazz od podstaw po poziom zaawansowany
            </p>
            <ul className="mt-6 divide-y divide-night-600" data-id="element-335" data-mp="pmu77wvqylke">
              {coverage.map((item, index) => <li key={item} className="flex items-baseline gap-4 py-3.5 text-sm text-cream-soft first:pt-0 last:pb-0" data-id="element-336" data-mp="knhlxgkixmjx" data-mpi={index}>
                  <span className="text-xs font-semibold tabular-nums text-amber" data-id="element-337" data-mp="1w36845pyehjo">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}